import { APIClient } from "../base";
import { PaginationInterface } from "../../../interfaces/PaginationInterface";

const UserApi = {
    register: async (model: any) => await APIClient.create('/register', model),
    ResetPassword: async (model: { password_confirm: string, password: string, email: string, sign: string, expire: string, agreement_no?: string }) => await APIClient.create('/reset-password', model),
    ForgotPassword: async (model: { email: string }) => await APIClient.create('/forgot-password', model),
    checkExistEmail: async (model: { accountNumber: string|number, token: string }) => await APIClient.get('/is-exist-email', model),
    registerFromEconomic: async (model: {
        token: string,
        accountNumber: string|number,
        email: string,
        password: string,
        password_confirm: string,
    }) => await APIClient.create('/register-from-economic', model),
    ChangePassword: async (model: { current_password: string, new_password: string, new_password_confirm: string }) => await APIClient.create('user/change-password', model),
    getAll: async (pagination: PaginationInterface) => await APIClient.get('/user/list-user-by-admin', pagination),
    getInfoCompany: async (model:{token: string}) => await APIClient.get('/get-info-company', model),
    switchUser: async (id: number|any) => await APIClient.get(`/user/switch-user-by-id/${id}`, {}),
    /** @deprecated Legacy /config signup. Prefer registerFromEconomic. */
    registerByEconomic:async (model: any) => await APIClient.create('/register-by-economic', model),
    toggleStatus:async (id: number|any) => await APIClient.put('/user/toggle-status', {id}),
    deleteByAdmin: async (id: number|any) => await APIClient.delete(`/user/${id}`, {}),
}

export default UserApi;
